// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const { downloadAsFile } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/actionTypes');
const { ACCOUNT_DETAILS_CERTIFICATE_TITULARIDAD } = require('constants/index');
import { VIEWER } from 'constants/contactCenter/pdfViewer';

// @ helpers
import { openPDFViewer, showPDFFailure } from 'utilities/contactCenter/pdfViewer';

const {
    GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_FETCHING,
    GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_SUCCESS,
    GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_ERROR,
    GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_CLEAR_STATE
} = actionTypes;

const requestAccountDetailsDocumentInProgress = (fileName) => ({
    type: GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_FETCHING,
    payload: {
        fileName
    }
});

const getAccountDetailsDocumentsSuccess = (fileName) => ({
    type: GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_SUCCESS,
    payload: {
        fileName
    }
});

const getAccountDetailsDocumentsError = (fileName, error) => ({
    type: GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_ERROR,
    payload: {
        fileName,
        error
    }
});

const clearAccountDetailDocumentState = () => ({
    type: GET_ACCOUNT_DETAILS_CERTIFICATES_PDF_CLEAR_STATE
});

const getAccountDetailsDocuments = (fileName, ibanComplex, loadType) => (dispatch) => {
    const requestData = {
        query: {
            pais: ibanComplex.get('pais'),
            codban: ibanComplex.get('codbban'),
            digitoControl: ibanComplex.get('digitodecontrol')
        },
        header: {
            accept: 'application/pdf',
            responseType: 'arraybuffer'
        }
    };
    dispatch(requestAccountDetailsDocumentInProgress(fileName));
    let url, downloadFileName;
    if (fileName === ACCOUNT_DETAILS_CERTIFICATE_TITULARIDAD) {
        url = apiURLBuilder.getURL('accountOwnershipCertificate');
        downloadFileName = formatText('certificateSection-titularidad');
    } else {
        url = apiURLBuilder.getURL('accountBalanceCertificate');
        downloadFileName = formatText('certificateSection-saldo');
    }

    return APIPost(dispatch, url, requestData)
        .then(response => {
            if(loadType === VIEWER){
                openPDFViewer(response.xhr.response);
            }else{
                downloadFileName = downloadFileName + '_' + ibanComplex.get('codbban') + '.pdf';
                downloadAsFile(response.xhr.response, 'application/pdf', downloadFileName);
            }
            dispatch(getAccountDetailsDocumentsSuccess(fileName))
        })
        .catch(error => {
            if(loadType === VIEWER){
                showPDFFailure();
            }
            dispatch(getAccountDetailsDocumentsError(fileName, error))
        });
}

module.exports = {
    getAccountDetailsDocuments,
    clearAccountDetailDocumentState
}
